module.exports = __webpack_public_path__ + "img/currency.2c1acfe8.svg";